import LineItem from './BookingSummaryLineItem'

class BookingSummary {
    constructor() {
        this.lineItems = {}
        this.initializeLineItems()
        this.updateTotal()
    }

    initializeLineItems() {
        const lineItems = document.querySelectorAll('.booking-summary__line-items--item')
        lineItems.forEach((lineItem) => {
            const dataName = lineItem.getAttribute('data-item-name')
            if (dataName !== 'total') {
                const description = lineItem.querySelector('.booking-summary__description').innerText
                const cleanedDescription = description.endsWith(':') ? description.slice(0, -1) : description;
                const price = parseFloat(lineItem.querySelector('.booking-summary__amount').innerText)
                this.lineItems[dataName] = new LineItem(dataName, cleanedDescription, price)
            }
        })
    }

    processLineItem(dataName, description, price, soRate = 0) {
        if (!price) {
            this.removeLineItem(dataName)
        } else {
            if (this.lineItems[dataName]) {
                this.removeLineItem(dataName)
            }
            const lineItem = new LineItem(dataName, description, price, soRate)
            this.lineItems[dataName] = lineItem
            this.addLineItemToLineItems(lineItem.element)
        }
        this.updateTotal()
    }

    removeLineItem(dataName) {
        if (this.lineItems[dataName]) {
            this.lineItems[dataName].remove()
            delete this.lineItems[dataName]
            this.updateTotal()
        }
    }

    addLineItemToLineItems(lineItemElement) {
        const totalLineItem = document.querySelector('.booking-summary__line-items--item[data-item-name="total"]')
        const parent = document.querySelector('.booking-summary__line-items')
        const lineItemsArray = Array.from(parent.querySelectorAll('.booking-summary__line-items--item:not([data-item-name="total"])'))

        const insertBeforeElement = lineItemsArray.find(currentItem =>
            parseInt(currentItem.getAttribute('data-item-order')) > parseInt(lineItemElement.getAttribute('data-item-order'))
        )

        parent.insertBefore(lineItemElement, insertBeforeElement || totalLineItem)
    }

    updateTotal() {
        const total = Object.values(this.lineItems).reduce((sum, lineItem) => sum + parseFloat(lineItem.price), 0)
        const lineItemsArray = Array.from(document.querySelectorAll('.booking-summary__line-items--item:not([data-item-name="total"])'))
        let totalSum = 0
        lineItemsArray.forEach((lineItem) => {
            totalSum += parseFloat(lineItem.querySelector('.booking-summary__amount').getAttribute('data-amount'))
        })
        const totalLineItem = document.querySelector('.booking-summary__line-items--item[data-item-name="total"]')
        if (totalLineItem) {
            totalLineItem.querySelector('.booking-summary__amount').innerText = totalSum.toFixed(2)
        }
    }  
}

export default BookingSummary
